$(document).ready(function () {
  const pageProductId = $('.pdp.product').data('productid');
  var requestHost = window.location.host;
  var store = "aime-leon-dore";
  if (requestHost.indexOf("eu-dev") > -1) store = "aime-leon-dore-eu-dev";
  else if (requestHost.indexOf("dev") > -1) store = "aime-leon-dore-dev-store";
  else if (requestHost.indexOf("eu") > -1) store = "aime-leon-dore-eu";

  var apiDomain = "https://ald-filter.herokuapp.com/api";
  if (requestHost === "aime-leon-dore-dev-store.myshopify.com") {
    apiDomain = "https://ald-filter-staging.herokuapp.com/api";
  }

  function getShipDelayFromSelect($select) {
    if(!$select || !$select.length) return null;
    const $opt = $select.find(':selected');
    const delayFlag = $opt.data('ship-delay');
    const shipDelayMessage = $opt.data('ship-delay-message');
    const hasDelay = (delayFlag === true || delayFlag === 'true') && !$opt.hasClass('disabled-el');
    if(hasDelay) {
      return shipDelayMessage || ''
    }
    return null;
  }

  function normalizeJewelryAttr(value) {
    if (!value) {
      return '';
    }
    return String(value)
      .split('//')
      .filter(function(entry) { return entry && entry.trim() !== ''; })
      .join('//');
  }

  function buildUpsellHTML(product, collapsed = false) {
    if(product.product_id) {
      var price = formatPrice(product.local_price.price, product.local_price.currency);
      var compareAtPrice = price;
      if(!product.sold_out && product.local_price.compare_at_price !== null) {
        compareAtPrice = product.local_price.compare_at_price;
      } else {
        compareAtPrice = 0;
      }
      var priceToDisplay = '';
      var classCompare = '';

      priceToDisplay += '<span class="money">'+price+'</span>';
      if(product.local_price.price < compareAtPrice && product.local_price.compare_at_price != 0) {
        compareAtPrice = formatPrice(product.local_price.compare_at_price, product.local_price.currency);
        priceToDisplay += '<span class="plp-product__price__compare">'+compareAtPrice+'</span>';
        classCompare = 'plp-product__price--compare';
      }

      var images = '';
      for(var j in product.images) {
        if(j != 0) {
          if(product.images[j].alt != 'dev-product-image-swatch') {
            images += `                    <div class="swiper-slide upsell-carousel__item">
              <img src="${product.images[j].url}&width=600" alt="" />
            </div>`
          }
        }
      }
      var sizes = '<select class="custom-select" name="sizes-'+product.product_id+'">';
      
      var swatchesMobile = '<option value="">Select Color</option>';
      var swatches = '';
      var swatchesIds = '';

      for(var z in product.handles_info) {
        var swatchData = product.handles_info[z];
        var swatchHandle = Object.keys(swatchData);
        var swatchId = Object.values(swatchData);
        swatchesIds += Object.values(swatchData) + ',';

        if(product.tags.indexOf('dev-jewelry-main') > -1) {
          swatchesIds = jewelrySwatchIds;
        }

        var selected = '';
        var selectedClass = '';
        if(product.product_id == swatchId) {
          selected = 'selected';
          selectedClass = 'swatch-colors__item--selected';
        }

        var colors = product.handles[0];
        colors = Object.values(colors);
        colors = colors[0];

        if(typeof colors === 'string') {
          colors = colors.replace(/\([^)]*\)/g, '').split(',').map(function(entry) {
            return entry.trim();
          }).filter(function(entry) {
            return entry !== '';
          });
        }

        colors = colors[z];

        swatches += `<a href="/products/${swatchHandle}" class="swiper-slide ${selectedClass} swatch-colors__item upsell-toggle" id="${product.product_id}" new="" data-color="${colors}" data-swatchid="${swatchId}" data-swatchids="${swatchesIds}">
                  <div class="image-square product-image">
                  </div>
                </a>`

        swatchesMobile += `<option ${selected} data-img="" data-swatchid="${swatchId}">${colors}</option>`
      }

      if(product.handles_info == null) {
        swatchesMobile = `<option selected data-img="${product.image_url}&width=100" data-swatchid="">${product.variants[0].color}</option>`;
      }

      swatchesIds = swatchesIds.slice(0, -1);

      const shipDelaySku = product.metafields?.find(mf => mf.ship_delay_skus)?.ship_delay_skus || '';
      const shipDelayMessage = product.metafields?.find(mf => mf.ship_delay_message)?.ship_delay_message || '';

      if(product.variants.length == 1) {
        sizes += '<option value=""></option>';
        const singleHasDelay = shipDelaySku.indexOf(product.variants[0].sku) > -1 && !product.variants[0].sold_out;
        const singleDelayAttr = ` data-ship-delay="${singleHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
          // Tier number only -- copy comes from window.ALDLowStock and the unit count
          // never leaves the backend.
          ` data-low-stock-tier="${product.variants[0].low_stock_tier ?? ''}"`;
        if(product.variants[0].sold_out) {
          sizes += `<option class="disabled-el" data-soldout="${product.variants[0].sold_out}" data-productid="${product.variants[0].product_id}" data-sku="${product.variants[0].sku}"${singleDelayAttr} value="${product.variants[0].id}">${product.variants[0].size}</option>`;
        } else {
          sizes += `<option data-soldout="${product.variants[0].sold_out}" selected value="${product.variants[0].id}" data-productid="${product.variants[0].product_id}" data-sku="${product.variants[0].sku}"${singleDelayAttr}>${product.variants[0].size}</option>`;
        }
      } else {
        for(var k in product.variants) {
          sizes += '<option value=""></option>';
          const variantHasDelay = shipDelaySku.indexOf(product.variants[k].sku) > -1 && !product.variants[k].sold_out;
          const delayAttr = ` data-ship-delay="${variantHasDelay}" data-ship-delay-message="${shipDelayMessage}"` +
            // Tier number only -- copy comes from window.ALDLowStock and the unit count
            // never leaves the backend.
            ` data-low-stock-tier="${product.variants[k].low_stock_tier ?? ''}"`;
          if(product.variants[k].sold_out) {
            sizes += `<option class="disabled-el" data-soldout="${product.variants[k].sold_out}" data-sku="${product.variants[k].sku}" data-productid="${product.variants[k].product_id}"${delayAttr} value="${product.variants[k].id}">${product.variants[k].size}</option>`;
          } else {
            sizes += `<option data-soldout="${product.variants[k].sold_out}" data-sku="${product.variants[k].sku}" data-productid="${product.variants[k].product_id}"${delayAttr} value="${product.variants[k].id}">${product.variants[k].size}</option>`;
          }
        }
      }

      sizes += '</select>';

      var showSelectOptions = 'd-none';
      var showAddToCart = '';
      var jewelryClass = '';
      if(product.tags.indexOf('dev-jewelry-main') > -1) {
        jewelryClass = 'chain-selector';
        showSelectOptions = 'd-block';
        showAddToCart = 'd-none d-lg-block';
        sizes = $('.chain-select')[0].outerHTML;

        swatches = $('.jewelry-swatches-clone .product__variants .swiper-wrapper')[0].innerHTML;

        swatchesMobile = $('.pendant-select')[0].innerHTML;
      } 

      var colorName = product.variants[0].color;

      if(product.tags.indexOf('PREORDER_PRODUCT') > -1) {
        customTag = '<div class="plp-product__tag">Reserve</div>';
      }
      if(product.tags.indexOf('NEW_PRODUCT') > -1) {
        customTag = '<div class="plp-product__tag">NEW</div>  ';
      }

      var addToBag = 'Add To Bag';
      if(product.sold_out) {
        addToBag = 'Notify Me';
      }

      var nonUSProduct = '';
      var nonUSProductTpl = '';
      if(product.tags.indexOf('dev-non-us-oos') > -1) {
        if(Shopify.country !== 'US') {
          nonUSProduct = ' style="display: none !important;"';

          var customLink = '';
          var customName = '';
          for(const i in product.metafields) {
            if(product.metafields[i]['non_us_oos_label'] !== undefined) {
              priceToDisplay = product.metafields[i]['non_us_oos_label']
            }
            if(product.metafields[i]['non_us_oos_button_link'] !== undefined) {
              customLink = product.metafields[i]['non_us_oos_button_link']
            }
            if(product.metafields[i]['non_us_oos_button_name'] !== undefined) {
              customName = product.metafields[i]['non_us_oos_button_name']
            }
          }

          nonUSProductTpl = `          <div class="upsell-form">
            <div class="atc-box">
              <a href="${customLink}" class="btn btn--dark btn--bag btn-upsell-add btn-upsell-add--stl">${customName}</a>
              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
            </div>
          </div>` 
        }
      }

      const collapseClass = collapsed ? ' cart-upsell-collapse' : '';
      return `<div class="cart-upsell${collapseClass}" data-productid="${product.product_id}" data-variantid="${product.variants[0].id}" id="popup-upsell-${product.product_id}" data-productsku="${product.variants[0]?.sku || undefined}" data-color="${product.variants[0]?.color || undefined}" data-swatchids="${swatchesIds}">
        <button class="close-upsell d-none" aria-label="Close product details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 15L15 1M1 1L15 15" stroke="#181818" stroke-width="2" aria-hidden="true"/>
        </svg></button>
        <div class="upsell-carousel">
          <div class="swiper-wrapper">
            ${images}
          </div>
        </div>

        <div class="upsell-content product">
          <h2 class="product__title">${product.title}</h2>
          <div class="product__price  ${classCompare}" data-price="${product.local_price.price}">${priceToDisplay}</div>
          <div class="product__variants product__variants--colors d-none d-lg-block" ${nonUSProduct}>
            <div class="product-variants-title d-none d-lg-block">
              Color: ${colorName}
            </div>
            <div class="swatch-colors swiper-container">
              <div class="swiper-wrapper">
                ${swatches}
              </div>
            </div>
            <div id="swatch-colors-next" class="swiper-btn-next"></div>
            <div id="swatch-colors-prev" class="swiper-btn-prev"></div>
          </div>

          <form class="upsell-form" ${nonUSProduct}>
            <div class="random-div d-flex justify-content-between d-lg-block">
              <div class="product__variants--colors d-lg-none">
                <div class="custom-select-wrapper">
                  <select class="custom-select">
                    ${swatchesMobile}
                  </select>
                </div>
              </div>

              <div class="swatch-size swatch-size3 custom-select-wrapper ${showSelectOptions} d-lg-none">
                <select class="custom-select" disabled>
                  <option val="">One Size</option>
                </select>
              </div>

              <div class="swatch-size swatch-size4 custom-select-wrapper ${jewelryClass} ${showAddToCart}" id="sizes-${product.product_id}">
                  ${sizes}
              </div>
            </div>
            <div class="atc-box">
              <button name="add" id="select-options" type="button" class="select-options btn btn--dark btn--bag ${showSelectOptions} d-lg-none">Select Options</button>
              <button name="add" id="add-submit" type="submit" class="btn btn--dark btn--bag ${showAddToCart} btn-upsell-add btn-upsell-add--stl">${addToBag}</button>
              <div class="notify" style="display: none;">
                  <h4 class="notify__txt">Notify me when this product is in stock </h4>
                  <div class="form-group" style="margin-bottom: 8px; margin-top: 13px;">
                    <input type="email" id="notify_email" placeholder="Enter your email" name="EMAIL" class="notifyme-control form-control form-control--border" required>
                  </div>
                  <input type="button" id="notify" class="btn btn--dark" value="Submit" />
                  <p class="notify-success-message btn btn--light" style="display: none;">you're on the list</p>

                  <div class="bis-newsletter-signup">
                    <input type="checkbox" checked id="bis-newsletter" name="bis-newsletter" class="bis-custom-checkbox">
                    <label for="bis-newsletter"><span class="bn-out"><span class="bn-in"></span></span><span class="bn-txt">Sign me up for the mailing list</span></label>
                    <div class="global-privacy-notice-element-small">By providing your email address, you agree to our <a href="${privacyPolicyFileLink}" target="blank">Privacy Policy</a>.</div>
                  </div>
              </div>
              <a href="/products/${product.handle}" class="link text-center upsell-full-details-btn" target="_blank" rel="noopener noreferrer">FULL DETAILS</a>
            </div>
          </form>

          ${nonUSProductTpl}
        </div>
      </div>`;
    } else {
      return null;
    }
  }

  /* ---------- resize / modal width ---------- */
  function adjustUpsellWidth () {
    if (window.innerWidth > 1024) {
      const h      = window.innerHeight;
      const imgH   = h - 340;
      const boxW   = Math.floor((4 * imgH) / 5);
      $('.upsell-carousel, .cart-upsell').width(boxW);
      if (boxW > 493) $('.upsell-carousel img').css('width', '100%');
      else            $('.upsell-carousel img').css('width', '');
    } else {
      $('.upsell-carousel, .cart-upsell').css('width', '');
    }
  }
  $(window).on('resize', adjustUpsellWidth);

  function initUpsellUI () {

    /* ---------- modal width ---------- */
    const isDesktop = window.innerWidth > 1024;
    if (isDesktop) {
      const imgH  = window.innerHeight - 340;
      const boxW  = Math.floor((4 * imgH) / 5);
      $('.upsell-carousel, .cart-upsell').width(boxW);
      $('.upsell-carousel img').css('width', boxW > 493 ? '100%' : '');
    } else {
      $('.upsell-carousel, .cart-upsell').css('width', '');
    }
  
    /* ---------- swiper ---------- */
    if ($('.upsell-carousel').length) {
      new Swiper('.upsell-carousel', {
        spaceBetween : 7,
        slidesPerView: 'auto',
        breakpoints  : { 1025: { slidesPerView: 1, spaceBetween: 0, watchOverflow: true } },
        on: {
          slideChange: function () {
            var newIndex = this.activeIndex + 1;
            if (typeof gtag === 'function') {
              const productId = $('.cart-upsell').data('productid');
              const productColor = $('.cart-upsell').data('color');
              gtag('event', `PDP_${pageProductId}_Quickview_Image Swipe_${newIndex}_${productId}_${productColor}`);
            }
          }
        }
      });
    }
  
    if ($('.cart-upsell .swatch-colors').length) {
      new Swiper('.swatch-colors', {
        slidesPerView: 'auto',
        navigation   : { nextEl: '#swatch-colors-next', prevEl: '#swatch-colors-prev' }
      });
    }
  
    /* ---------- Select2: sizes ---------- */
    $('.cart-upsell .swatch-size .custom-select').each(function () {
      const $wrapper = $(this).closest('.custom-select-wrapper');
      $(this).select2({
        dropdownParent        : $wrapper,
        minimumResultsForSearch: -1,
        placeholder           : 'Select Size',
        dropdownCssClass      : 'custom-select-dropdown',
        templateResult        : (data) => {
          const $opt = $(data.element);
          if ($opt.hasClass('disabled-el')) {
            return $(
              `<span class="notify-me-item-wrapper">${data.text}` +
              '<span class="notify-me-mobile"> Notify Me</span></span>'
            );
          }
          const delayFlag = $opt.data('ship-delay');
          const shipDelayMessage = $opt.data('ship-delay-message');
          const hasDelayMessage = (delayFlag === true || delayFlag === 'true') && shipDelayMessage;
          if(hasDelayMessage) {
            return $(
              `<span class="notify-me-item-wrapper">${data.text}` +
              `<span class="notify-me-mobile"> ${shipDelayMessage}</span></span>`
            );
          }
          // Tier -> copy via window.ALDLowStock, published by snippets/low-stock-config.liquid
          // from the same shop metafields the backend reads thresholds from. Guarded so a
          // missing global degrades to no message rather than breaking the dropdown.
          const lowStockMessage = (window.ALDLowStock && window.ALDLowStock.messageForTier)
            ? window.ALDLowStock.messageForTier($opt.data('low-stock-tier'))
            : '';
          if (lowStockMessage) {
            return $(
              `<span class="notify-me-item-wrapper">${data.text}` +
              `<span class="notify-me-mobile"> ${lowStockMessage}</span></span>`
            );
          }
          return $(`<span>${data.text}</span>`);
        }
      });
    });
  
    /* ---------- Select2: chain-select ---------- */
    $('.cart-upsell .swatch-size .chain-select').each(function () {
      const $wrapper = $(this).closest('.custom-select-wrapper');
      $(this).select2({
        dropdownParent        : $wrapper,
        minimumResultsForSearch: -1,
        placeholder           : 'Select Size',
        dropdownCssClass      : 'custom-select-dropdown',
        templateResult        : (data) => {
          const price = $(data.element).data('price') || 0;
          const suffix = price ? `+ ${price}` : '';
          return $(
            `<span class="notify-me-item-wrapper">${data.text}` +
            `<span class="notify-me-mobile">${suffix}</span></span>`
          );
        }
      });
    });

    $('.cart-upsell-container')
      .off('change.shopLookChain', 'select.chain-select')
      .on('change.shopLookChain', 'select.chain-select', function () {
        const $select = $(this);
        const $upsell = $select.closest('.cart-upsell');
        const selectedChainId = parseInt($select.find(':selected').data('prodid'), 10) || 0;
        window.chainId = selectedChainId;
        $upsell.attr('data-chainid', selectedChainId);

        const basePrice = parseFloat($upsell.find('.product__price').data('price')) || 0;
        const chainPrice = parseFloat($select.find(':selected').data('original-price')) || 0;
        const totalPrice = basePrice + chainPrice;
        const $priceWrap = $upsell.find('.product__price');
        const $moneyEl = $priceWrap.find('.money').first();
        if (typeof formatPrice === 'function') {
          var currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : (typeof globalCurrency !== 'undefined' ? globalCurrency : 'USD');
          const formatted = formatPrice(totalPrice, currencyCode);
          if ($moneyEl.length) {
            $moneyEl.text(formatted);
          } else {
            $priceWrap.text(formatted);
          }
        } else if ($moneyEl.length) {
          $moneyEl.text(totalPrice.toFixed(2));
        } else {
          $priceWrap.text(totalPrice.toFixed(2));
        }

        $upsell.find('.btn-upsell-add')
          .removeClass('d-none')
          .prop('disabled', false)
          .text('Add To Bag')
          .show();
      });

    /* ---------- variant change ---------- */
    $('.cart-upsell .swatch-size select, .swatch-size-2 select').off('change.initUpsell')
      .on('change.initUpsell', function () {
        const selected = $(this).find(':selected');
        const selectedProductId = $(selected).data('productid');

        $('.cart-upsell-container .select-error').removeClass('select-error');
        $('.cart-upsell-container .size-error').hide();
        $('.cart-upsell-container #show-bis').hide();
  
        const soldOut = $(this).find(':selected').hasClass('disabled-el');
        $('.cart-upsell-container .btn-upsell-add').toggle(!soldOut);
        $('.cart-upsell-container .notify').toggle(soldOut);
  
        BISHandler($(this).val());

        // PDP_[Parent Product id]_Quickview_Select Size: [Size]_[SKU]_[Product Color]
        if (typeof gtag === 'function') {
          gtag('event', `PDP_${pageProductId}_Quickview_Select Size: ${selected.text()}_${selected.data('sku')}_${selectedProductId}`);
        }
      });
  
    /* ---------- color mobile change ---------- */
    $('.cart-upsell .product__variants--colors select').off('change.initUpsellVariant')
      .on('change.initUpsellVariant', function () {
        const selected = $(this).find(':selected');
        const selectedProductId = $(selected).data('swatchid');
        const upsellProductId = $('.cart-upsell.cart-upsell-collapse').data('productid');

        if(upsellProductId != selectedProductId) {
          renderQuickview(selectedProductId, 'swap');
          
          // PDP_[Parent Product id]_Quickview_Select: [Color]_[product id]
          if (typeof gtag === 'function') {
            gtag('event', `PDP_${pageProductId}_Quickview_Select: ${selected.text()}_${selectedProductId}`);
          }
        }
      });

    const initMobileColors = () => {
      /* ---------- Select2: colors ---------- */
      $('.cart-upsell .product__variants--colors .custom-select').each(function () {
        const $wrapper = $(this).closest('.custom-select-wrapper');
        $(this).select2({
          dropdownParent        : $wrapper,
          minimumResultsForSearch: -1,
          placeholder           : 'Select Color',
          dropdownCssClass      : 'custom-select-dropdown',
          templateResult        : (data) => {
            const id  = $(data.element).data('swatchid');
            const img  = $(data.element).data('img');
            return $(`<span><span class="product-image">${img ? `<img src="${img}&width=30">` : ''}</span>${data.text}</span>`);
          },
          templateSelection     : (opt) => {
            const id  = $(opt.element).data('swatchid');
            const img  = $(opt.element).data('img');
            return $(`<span><span class="product-image">${img ? `<img src="${img}&width=30">` : ''}</span>${opt.text}</span>`);
          }
        });
      });
    }

    /* ---------- swatch images ---------- */
    const elements = $('.swatch-colors .upsell-toggle');
    const swatchIds = elements.map(function() {
      return parseInt($(this).data('swatchid'));
    }).get();
    if(elements.length) {
      fetchProducts(swatchIds, function (arr) {
  
        if(arr.length) {
          arr.forEach((product) => {
            const swatchImage = product?.images?.find((image) => image?.alt === 'dev-product-image-swatch') || product?.images?.[0];
            const swatchColor = product?.handles[0].colors;
    
            if(swatchImage) {
              $(`.cart-upsell .swatch-colors .upsell-toggle[data-swatchid="${product?.product_id}"] .product-image`).append(`<img src="${swatchImage?.url}&width=100" a alt="${swatchColor}">`);
              $(`.cart-upsell .custom-select-wrapper option[data-swatchid="${product?.product_id}"]`).data('img', swatchImage?.url);
            }
          })
        }
        initMobileColors();
      })
    } else {
      initMobileColors();
    }
  }

  function BISCallback (data) {
    let msg     = '';
    let success = true;
  
    if (data.status === 'OK') {
      $('.notify-success-message').show();
      $('.notify h4, .notify input').hide();
      $('.bis-newsletter-signup').hide();
    } else {
      Object.keys(data.errors || {}).forEach((k) => { msg += data.errors[k].join(); });
  
      const $txt = $('.notify__txt').addClass('atc-error');
      if (msg === 'You have already registered for a notification for that item.') {
        $txt.text('You have already registered for a notification.').show();
      } else {
        $txt.text('Please enter a valid email address').show();
      }
  
      $('#notify_email').addClass('atc-error');
      $txt.addClass('bis-error');
      success = false;
    }
  
    if (success) {
      setTimeout(() => {
        $('.notify h4')
          .text('Notify me when this product is in stock')
          .removeClass('atc-error');
  
        $('.notify h4, .notify input, #notify').show();
        $('.notify input[type="email"]').val('');
        $('.notify-success-message').hide();
        $('#add-submit').show();
  
        $('.swatch-size .custom-select').val('').trigger('change');
        $('#show-bis').show();
        $('.notify').hide();
        $('.swatch-size__item input:checked').prop('checked', false);
  
        $('#k_id_email_product').val(biseml);
        $('#email_signup_product').trigger('submit');
      }, 4000);
    }
  }

  function BISHandler () {
    $('.cart-upsell-container')
      .off('click.bis')
      .on('click.bis', '#notify', function (e) {
        e.preventDefault();
  
        const $notify   = $('.cart-upsell-collapse');
        const variantId = $notify.find('.swatch-size select').val();
        const email     = $notify.find('#notify_email').val();
        const productId = $(this).closest('.cart-upsell').data('productid');
  
        if (!variantId) {
          $notify.find('.swatch-size').addClass('select-error');
          return;
        }
  
        if (!email || email.indexOf('@') === -1) {
          $notify.find('.notify__txt')
            .addClass('atc-error')
            .text('Please enter a valid email address')
            .show();
          $notify.find('#notify_email').addClass('atc-error');
          if (window.innerWidth < 1025) {
            $notify.find('#notify_email').val('enter a valid email address');
          }
          return;
        }
  
        $notify.find('.notify__txt').hide();
        $notify.find('#notify_email').removeClass('atc-error');
        BIS.create(email, variantId, productId);
  
        $notify.find('.notify-success-message').show();
        $notify.find('.notify h4, .notify input').hide();
        $notify.find('.bis-newsletter-signup').hide();
      });
  }
  
  function fetchProducts(ids, cb) {

    var dataToSend = JSON.stringify({ store_name: store, product_ids: ids, iso_code: Shopify.country })

    if(window.location.host.indexOf('eu') > -1) {
      var locationId = 50003247253;
      if($('body').attr('data-country') == 'GB') {
        locationId = 74146152597;
      }

      dataToSend = JSON.stringify({ store_name: store, product_ids: ids, iso_code: Shopify.country, location_ids: [locationId] })
    }

    $.ajax({
      url: apiDomain + "/product_info",
      method: "POST",
      data: dataToSend,
      contentType: "application/json",
      dataType: "json",
      success: function (res) {
        cb(Object.values(res) || []);
      },
    });
  }

  function getQuickviewShell() {
    let $overlay = $('.cart-upsell-overlay');
    let $container = $('.cart-upsell-container');

    if (!$overlay.length || !$container.length) {
      $overlay   = $('<div class="cart-upsell-overlay cart-upsell-overlay--visible"></div>');
      $container = $('<div class="cart-upsell-container cart-upsell-container--visible"></div>');
      $('body').append($overlay, $container).addClass('cart-upsell--visible');
      $overlay.on('click', closeQuickview);
      $container.on('click', '.close-upsell', closeQuickview);
    } else {
      $overlay.addClass('cart-upsell-overlay--visible');
      $container.addClass('cart-upsell-container--visible');
      $('body').addClass('cart-upsell--visible');
    }

    return $container;
  }

  function handleUpsellAdd(e) {
    e.preventDefault();
    const $button     = $(this);
    const $upsell     = $button.closest('.cart-upsell');
    const chainExists = $upsell.find('.chain-select').length > 0;

    const variantId   = $upsell.data('variantid');
    const basePayload = {
      quantity  : 1,
      id        : variantId,
      properties: { _shopthelook: 'true' }
    };
    const shipDelayValue = getShipDelayFromSelect($upsell.find('.swatch-size4 select'));
    if(shipDelayValue) {
      basePayload.properties['_ship_delay'] = shipDelayValue;
    }

    if(raffleCount && raffleCount > 0) {
      $('.raffle-overlay, .raffle-mismatch-regular').show();
      return;
    }

    // PDP_[Parent Product id]_Quickview_Add to Bag_[SKU]_[Product Color]
    if (typeof gtag === 'function') {
      const selectedSize = $upsell.find('.swatch-size4 select').find(':selected');
      const addedSku = selectedSize.data('sku');
      gtag('event', `PDP_${pageProductId}_Quickview_Add to Bag_${addedSku || $upsell.data('productsku')}_${$upsell.data('color')}`);
    }

    if (chainExists) {
      $.post('/cart/add', basePayload, () => {
        if (typeof chainId !== 'undefined' && chainId !== 0) {
          const attrs = (window.jewelryAtrributes || '') ?
                        `${window.jewelryAtrributes}//` : '';

          const chainPayload = {
            quantity  : 1,
            id        : chainId,
            attributes: { jewelry: `${attrs}${variantId}::${chainId}` },
            properties: { _shopthelook: 'true' }
          };

          $.post('/cart/add', chainPayload)
            .done(() => {
              window.jewelryAtrributes = `${attrs}${variantId}::${chainId}`;
              $button.text('PRODUCT ADDED TO BAG').attr('disabled', true);
              closeQuickview();
              let count = $('.cart-count').text();
              count = (parseInt(count) || 0) + 1;
              if(increaseCounter) {
                $('.cart-count').text(count);
                $('.cart-ic').addClass('active-cart');
                if(limitedQty) {
                  increaseCounter = false;
                }
              }
            })
            .fail(() => alert('No more units available.'));
        } else {
          const attrs = (window.jewelryAtrributes || '') ?
                        `${window.jewelryAtrributes}//` : '';

          $.ajax({
            url   : '/cart/update.js',
            method: 'POST',
            data  : `attributes[jewelry]=${attrs}${variantId}::${chainId}`,
            dataType: 'json'
          }).done(() => {
            window.jewelryAtrributes = `${attrs}${variantId}::${chainId}`;
            $button.text('PRODUCT ADDED TO BAG').attr('disabled', true);
            closeQuickview();
            let count = $('.cart-count').text();
            count = (parseInt(count) || 0) + 1;
            if(increaseCounter) {
              $('.cart-count').text(count);
              $('.cart-ic').addClass('active-cart');
              if(limitedQty) {
                increaseCounter = false;
              }
            }
          });
        }
      });

      return;
    }

    const variantSolo = $button
      .closest('.upsell-form')
      .find('.swatch-size4 select')
      .val() || '';

    const $sizeWrap   = $button.closest('.upsell-form').find('.swatch-size');
    const variantChosen = variantSolo !== '';

    if (!variantChosen) {
      $sizeWrap.addClass('select-error');
      return;
    }
    $sizeWrap.removeClass('select-error');

    const soloPayload = {
      quantity  : 1,
      id        : variantSolo,
      properties: { _shopthelook: 'true' }
    };
    if(shipDelayValue) {
      soloPayload.properties['_ship_delay'] = shipDelayValue;
    }
    
    $.post('/cart/add', soloPayload, () => {
      $button.text('PRODUCT ADDED TO BAG').attr('disabled', true);
      closeQuickview();
      let count = $('.cart-count').text();
      count = (parseInt(count) || 0) + 1;
      if(increaseCounter) {
        $('.cart-count').text(count);
        $('.cart-ic').addClass('active-cart');
        if(limitedQty) {
          increaseCounter = false;
        }
      }
    });
  }

  function renderQuickview(productId, source) {
    const id = Number(productId);
    if (Number.isNaN(id)) {
      return;
    }
    const eventSource = source || 'Quickview_Open';
    const currentId = $('.cart-upsell-container .cart-upsell').data('productid');
    if (currentId && Number(currentId) === id && eventSource === 'swap') {
      return;
    }

    const $container = getQuickviewShell();

    fetchProducts([id], function (arr) {
      const product = arr && arr[0];
      if (!product || !product.product_id) {
        if (eventSource !== 'swap') closeQuickview();
        return;
      }

      const keepCollapsed = eventSource === 'swap';
      console.log('shop the look - html vs append')
      $container.append(buildUpsellHTML(product, keepCollapsed));
      initUpsellUI($container);

      $('.cart-upsell-container')
        .off('click.upsellAdd')
        .on('click.upsellAdd', '.btn-upsell-add--stl', handleUpsellAdd);

      if (!keepCollapsed) {
        $('#popup-upsell-' + product.product_id).addClass('cart-upsell-collapse');
      }
    });
  }

  function openQuickview(productId) {
    renderQuickview(productId, 'Quickview_Open');
  }

  function closeQuickview() {
    $('.cart-upsell-container .cart-upsell').removeClass('cart-upsell-collapse');
    setTimeout(() => {
      // $(".cart-upsell-overlay, .cart-upsell-container").remove();
      $("body").removeClass("cart-upsell--visible");
    }, 500);
  }

  $(document).on('click', '.cart-upsell-container .select-options', function() {
    $(this).closest('.upsell-form').find('.chain-selector').show().removeClass('d-none');
    $(this).hide().removeClass('d-block');
    $(this).next().show().removeClass('d-none');
    return false;
  });

  $(document).on("click", "#panel-content-shopthelook .plp-product", function (e) {
    e.preventDefault();
    var pid = $(this).data("product-id");
    var index = $(this).data("index");
    var color = $(this).data("color");
    openQuickview(pid);

    // PDP_[Parent Product id]_Shop the Look_[Position]_[Recommendation Product id]_[Product Color]
    if (typeof gtag === 'function') {
      gtag('event', `PDP_${pageProductId}_Shop the Look_${index}_${pid}_${color}`);
    }
  });

  $(document).on("click", ".cart-upsell-container .upsell-toggle", function (e) {
    e.preventDefault();
    var pid = $(this).data("swatchid");
    var color = $(this).data("color");
    var currentId = $('.cart-upsell-container .cart-upsell').data('productid');

    if (currentId && parseInt(currentId, 10) === parseInt(pid, 10)) {
      return;
    }

    renderQuickview(pid, 'swap');
    
    // PDP_[Parent Product id]_Quickview_Select: [Color]_[product id]
    if (typeof gtag === 'function') {
      gtag('event', `PDP_${pageProductId}_Quickview_Select: ${color}_${pid}`);
    }
  });
  
  $(document).on("click", ".cart-upsell-container .upsell-full-details-btn", function (e) {
    const productId = $(this).closest('.cart-upsell').data('productid');
    const productColor = $(this).closest('.cart-upsell').data('color');

    // PDP_[Parent Product id]_Quickview_Select: [Color]_[product id]
    if (typeof gtag === 'function') {
      if($(this).hasClass('upsell-ymal-btn')) {
        var prefix = 'US';
        if(window.location.href.indexOf('eu.') > -1) {
          prefix = 'EU';
        }
        var type = $('#producttype').val();
        gtag('event', `PDP_You May Also Like_${window.algoliaModelProper}_Quickview_Full Details_${type}_${productId}_${productColor}`);  
      } else {
        var type = $('#producttype').val();
        gtag('event', `PDP_Recently_Viewed_Quickview_Full Details_${type}_${productId}_${productColor}`);
        // diff between shop the look and recently viewed?
        //gtag('event', `PDP_${pageProductId}_Quickview_Full Details_${productId}_${productColor}`);  
      }
    }
  });
});
